import { browser } from "$app/environment";

/**
 * Whether the page is going away or out of sight right now.
 *
 * A request the browser aborts because the visitor left rejects with the same
 * "Load failed" / "Failed to fetch" as a real network failure. Failure events
 * carry this flag so the report can tell the two apart without dropping
 * either (hub ledger 2026-10-12-106). visibilityState covers a backgrounded
 * tab; the pagehide flag covers a navigation away, where visibility can still
 * read "visible" when the abort lands.
 */
let pageHiding = false;

if (browser) {
  window.addEventListener("pagehide", () => {
    pageHiding = true;
  });
  // A page restored from the back/forward cache is live again.
  window.addEventListener("pageshow", () => {
    pageHiding = false;
  });
}

export function isPageHidden() {
  if (!browser) return false;
  return pageHiding || document.visibilityState === "hidden";
}
